/* eslint no-confusing-arrow: ["error", {"allowParens": true}] */
/**
 * @returns {{getWindow: function, getDocument:function, getNavigator:function}}
 */

export default {
  getWindow: () => (typeof window !== 'undefined' ? window : {}),
  getDocument: () => (typeof document !== 'undefined' ? document : {}),
  getNavigator: () => (typeof navigator !== 'undefined' ? navigator : {}),
};
